import { FC } from 'react';
import { useDisclosure } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import * as Form from 'components/_core/form';
import SunshineModal from 'components/_core/SunshineModal';
import Text from 'components/_core/Text';

import locales from './locales';

interface ConfirmClientChangeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onValidate: (options: { doNotShowAgain: boolean }) => void;
  onCancel: () => void;
}

export const ConfirmClientChangeModal: FC<ConfirmClientChangeModalProps> = ({
  isOpen,
  onCancel,
  onClose,
  onValidate,
}) => {
  const { isOpen: isChecked, onToggle } = useDisclosure();

  return (
    <SunshineModal isOpen={isOpen} onClose={onClose}>
      <SunshineModal.Header />

      <SunshineModal.Body>
        <SunshineModal.Title>{locales.title}</SunshineModal.Title>

        <Text>{locales.content}</Text>

        <Form.Checkbox
          isChecked={isChecked}
          marginTop="space-16"
          onChange={onToggle}
        >
          <Form.Checkbox.Label color="primary" fontWeight="weight-500">
            {locales.checkbox}
          </Form.Checkbox.Label>
        </Form.Checkbox>
      </SunshineModal.Body>

      <SunshineModal.Footer>
        <Button onClick={onCancel} variant="inline-primary">
          {locales.cancel}
        </Button>

        <Button onClick={() => onValidate({ doNotShowAgain: isChecked })}>
          {locales.validate}
        </Button>
      </SunshineModal.Footer>
    </SunshineModal>
  );
};
